import cx from "classnames"
import PropTypes from "prop-types"
import React from "react"
import Container from "components/ui/Container"

function SkewedSection({ className, children }) {
  return (
    <section className={cx(className, "relative -z-20")}>
      <div className="absolute top-0 left-0 -z-1 h-full w-full -skew-y-6 bg-drift-grey" />
      <Container className="py-20 2xl:py-24">{children}</Container>
    </section>
  )
}

SkewedSection.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
  /** Section content */
  children: PropTypes.node,
}

export default SkewedSection
